import { createContext, useContext } from "react";

const EditShipmentLockContext = createContext(false);

export const EditShipmentLockProvider = EditShipmentLockContext.Provider;

export const useEditShipmentLock = () => useContext(EditShipmentLockContext);
